import classNames from 'classnames';
import React from 'react';
import styles from './ForwardStepsLocations.module.scss';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import ForwardStepsLocationsSchema from './ForwardStepsLocationsSchema';

import { useTranslation } from 'react-i18next';
import MultipleRouteLocationModelSimpleText, {
    MultipleRouteLocationModelSimpleTextDataKeys,
    MultipleRouteLocationModelSimpleTextData,
    iMultipleRouteLocationModelSimpleTextDisplayOptions
} from 'fulogics-ui-web/dist/layout/components/multiple-route-location-model-simple-text/MultipleRouteLocationModelSimpleText';

const ForwardStepsLocations = (props: ForwardStepsLocationsProps) => {
    const { t } = useTranslation('ForwardStepsLocations');

    const haveData = !!props?.data?.[0];

    return (
        <div className={classNames(styles.container, props.className)}>
            {haveData ? (
                <MultipleRouteLocationModelSimpleText
                    data={props.data}
                    className={props.className}
                    //
                    {...props.multipleRouteLocationOptions}
                />
            ) : (
                <label>{t('NoData')}</label>
            )}
        </div>
    );
};

export type ForwardStepsLocationsProps = {
    data?: ForwardStepsLocationsData;
} & ForwardStepsLocationsDisplayOptions;

export default withInspector<ForwardStepsLocationsProps>(
    ForwardStepsLocations,
    ForwardStepsLocationsSchema
);

export class ForwardStepsLocationsDisplayOptions {
    className?: string;
    //
    multipleRouteLocationOptions?: iMultipleRouteLocationModelSimpleTextDisplayOptions;
}

export type ForwardStepsLocationsData = MultipleRouteLocationModelSimpleTextData;

export const ForwardStepsLocationsDataKeys = MultipleRouteLocationModelSimpleTextDataKeys;
